import React, { useEffect } from "react";
import { Loading } from "../../components/common/Loading/Loading";
import { Protected } from "@/components/layout/Protected";
import { Box, Button, Container, createTheme, Divider, FormControlLabel, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Typography } from "@mui/material";
import { esES } from "@mui/material/locale";
import { PencilIcon } from "@/toolbox/constants/icons";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Popup } from "../Editor/components/Popup";
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import { Props } from "./Proveedor.type";
import {ModalProveedor} from './componentes/Modal/ModalProveedor';
import { proveedorService } from "@/service/services/Proveedor.service";
import { TOKEN_API } from "@/toolbox/constants/local-storage";
import { useLocalStorage } from '@toolbox/hooks/local-storage.hook';

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
);

export const Proveedor: React.FC<Props> = (props:Props): JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);

    const [openPopup, setOpenPopup] = React.useState<boolean>(false);
    const [editMode, setEditMode] = React.useState<boolean>(false);
    const [popUp, setPopUp] = React.useState<String>('');

    const [selectedProveedor, setSelectedProveedor] = React.useState<any>('');
    const [proveedores, setProveedores] = React.useState([]);
    const [token] = useLocalStorage(TOKEN_API, "");

    useEffect(() => {
        getProveedor();
      // eslint-disable-next-line
    }, []);

    const syncProveedores = async() => {
      setLoading(true);
      await proveedorService.validateProveedoresSofnet();
      await getProveedor();
    }

    // const getAndValidateClientSofnet = async () => {
    //   const cli = await fetch(`https://api2.softnet.cl/cliente`, {
    //   method: 'GET',
    //   headers: {
    //      'Access-Control-Allow-Origin':'*',
    //      'Content-Type': 'application/x-www-form-urlencoded',
    //      token: token,
    //   },
    //   })
    //   .then(proveedores => proveedores.json())
    //   .then(async proveedores => {
    //      let proveedoresPush = [];
    //   // eslint-disable-next-line
    //      proveedores.map((cli) => {
    //         if(cli.proveedor === "SI"){
    //            proveedoresPush.push(cli)
    //         }
    //      })

    //      return proveedoresPush;
    //   })
    //   .catch(error => {
    //      return []
    //   })
    //   return cli
    // }

    const getProveedor = async() => {
        setLoading(true);
        await proveedorService.getProveedores().then((data)=>{
            setProveedores(data);
            setLoading(false);
        })
    }

    const funcionSwitch = async(proveedor)=>{
        setLoading(true);
        if(proveedor.state === 1){
            await proveedorService.editState(proveedor.id, 0);
        }else{
            await proveedorService.editState(proveedor.id, 1);
        }
        getProveedor();
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container maxWidth='xl' sx={{ mt: 1, mb: 2 }}>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item>
                        <Typography variant='h4' >Gestión de Proveedores</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant='outlined' style={{textTransform: "capitalize", marginRight:'5px'}}
                        onClick={()=>{
                            syncProveedores();
                        }}
                        >Sincronizar Proveedor</Button>

                        <Button variant='outlined' style={{textTransform: "capitalize"}}
                        onClick={()=>{
                            setOpenPopup(true);
                            setEditMode(true);
                            setPopUp('addProveedor');
                        }}
                        >Crear Proveedor</Button>
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 2 }} />
                <Grid container spacing={1} >
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: '20px' }} >
                            {
                                (proveedores.length)  ? `${proveedores.length} registros encontrados`
                                    : `0` && !loading
                            }
                        </Typography>
                    </Grid>
                </Grid>
                <Grid>
                    {
                        proveedores.length > 0 && (
                            <Box sx={{Width: '100%', marginTop:'30px'}}>
                                <TableContainer component={Paper}>
                                    <ThemeProvider theme={theme}>
                                        <Table aria-label="simple table" size='small'>
                                            <TableHead>
                                                <TableRow  sx={{ bgcolor:'#1976D2'}}>
                                                    <TableCell sx={{ color: 'white' }} >
                                                        <strong>N°</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Razon Social</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>RUT</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Estado</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Observacion</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    proveedores.map((proveedor, id) =>(
                                                        <TableRow key={id}>
                                                            <TableCell component="th" scope="row">
                                                                {id+1}
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {proveedor.razon_social.toLowerCase()}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                {proveedor.rut}
                                                            </TableCell>

                                                            <TableCell align='center' component="th" scope="row">
                                                                <Box>
                                                                <FormControlLabel
                                                                    control={<Switch onClick={() => {
                                                                        funcionSwitch(proveedor);
                                                                    }}
                                                                />}
                                                                checked={proveedor.state === 1 ? true : false}
                                                                label=""
                                                                />
                                                                </Box>
                                                            </TableCell>

                                                            <TableCell align='center' component="th" scope="row">
                                                                {proveedor.observacion}
                                                            </TableCell>
                                                            <TableCell align='center'>
                                                                <Button
                                                                    onClick={() =>  {
                                                                        setOpenPopup(true);
                                                                        setEditMode(true);
                                                                        setPopUp('editProveedor');
                                                                        setSelectedProveedor(proveedor);
                                                                    }}
                                                                >
                                                                    <PencilIcon/>
                                                                </Button>

                                                                <Button
                                                                    onClick={() =>  {
                                                                        setOpenPopup(true);
                                                                        setEditMode(false);
                                                                        setPopUp('detailProveedor');
                                                                        setSelectedProveedor(proveedor);
                                                                    }}
                                                                >
                                                                    <VisibilityIcon/>
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </ThemeProvider>
                                </TableContainer>
                            </Box>
                        )
                    }
                    {
                        !loading && proveedores.length === 0 &&
                            <Grid container justifyContent="center">
                                <Box sx={{marginTop: '50px'}}>
                                <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                                    <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay Proveedores registrados</Box>
                                </Box>
                            </Grid>

                    }
                    {loading && proveedores.length === 0 &&
                     <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                     </Box>
                    }
                </Grid>
            </Container>
            {
                popUp === 'addProveedor' && (
                    <Popup
                        largo="sm"
                        title = 'Agregar Proveedor'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <ModalProveedor
                            closeModal={() => {setOpenPopup(false)}}
                            onListProveedor = {getProveedor}
                            editMode = {editMode}
                        />

                    </Popup>
                )
            }
            {
                popUp === 'editProveedor' && (
                    <Popup
                        largo="sm"
                        title = 'Editar Proveedor'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <ModalProveedor
                            closeModal={() => {setOpenPopup(false)}}
                            proveedor = {selectedProveedor}
                            onListProveedor = {getProveedor}
                            editMode = {editMode}
                        />

                    </Popup>
                )
            }
            {
                popUp === 'detailProveedor' && (
                    <Popup
                        largo="sm"
                        title = 'Detalle Proveedor'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <ModalProveedor
                            closeModal={() => {setOpenPopup(false)}}
                            proveedor = {selectedProveedor}
                            editMode = {editMode}

                        />

                    </Popup>
                )
            }
        </Protected>
    );
}
